export default "__VITE_ASSET__B9tLoY89__"